// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoData_noData__1Wm-K","dark":"NoData_dark__2JnVg","title":"NoData_title__3bRtC","description":"NoData_description__1tMEF"};